import { fetchData } from "./fetchData";

export const getTeamByID = async (teamID) => {
  try {
    const route = `/teams/${teamID}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllTeams = async (query) => {
  try {
    const route = `/teams${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const searchTeams = async (query) => {
  try {
    const route = `/teams/options?search=${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createTeam = async (formData) => {
  try {
    const route = `/teams`;

    const options = {
      method: "POST",
      Headers: {
        "Content-Type": "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getTeamSeasons = async (teamID, search = "") => {
  try {
    const route = `/teams/${teamID}/seasons${search ? `?search=${search}` : ""}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getTeamGames = async (teamID, query = "") => {
  try {
    const route = `/teams/${teamID}/games${query}`;

    const options = {
      method: "GET",
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};

export const updateTeam = async (teamID, formData) => {
  try {
    const route = `/teams/${teamID}`;

    const options = {
      method: "PUT",
      Headers: {
        "Content-Type": formData instanceof FormData ? "multipart/form-data" : "application/json",
      },
      body: formData,
    };

    let response = await fetchData(route, options);

    return response;
  } catch (error) {
    console.log(error);
  }
};
